import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const buildRuntimeRoadmapFromFirestore = async (roadmapRef) => {
  if (!roadmapRef?.phases?.length) return [];

  const phasePromises = roadmapRef.phases.map(async (refPhase) => {
    const phaseSnap = await getDoc(doc(db, "roadmap_phases", refPhase.phaseId));
    if (!phaseSnap.exists()) return null;

    const phase = {
      id: phaseSnap.id,
      ...phaseSnap.data(),
      weeks: [],
    };

    const weekPromises = refPhase.weeks.map(async (refWeek) => {
      const weekSnap = await getDoc(doc(db, "roadmap_weeks", refWeek.weekId));
      if (!weekSnap.exists()) return null;

      const week = {
        id: weekSnap.id,
        ...weekSnap.data(),
        days: [],
      };

      const dayPromises = refWeek.days.map(async (refDay) => {
        const daySnap = await getDoc(doc(db, "roadmap_days", refDay.dayId));
        if (!daySnap.exists()) return null;

        return {
          id: daySnap.id,
          ...daySnap.data(),
        };
      });

      const days = (await Promise.all(dayPromises))
        .filter(Boolean)
        .sort((a, b) => a.day - b.day);

      week.days = days;
      return week;
    });

    const weeks = (await Promise.all(weekPromises))
      .filter(Boolean)
      .sort((a, b) => a.week - b.week);

    phase.weeks = weeks;
    return phase;
  });

  const phases = (await Promise.all(phasePromises))
    .filter(Boolean)
    .sort((a, b) => a.order - b.order);

  return phases;
};
